'use client';

import { Container, IconButton, Stack, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

import Quote from '@/components/SvgIcons/Quote';
import LinkedIn from '@/components/SvgIcons/Socials/LinkedIn';
import colors from '@/styles/themes/colors';

import styles from './ExecutiveQuoteSection.module.scss';

const ExecutiveQuoteSection = () => {
  const t = useTranslations('office.executiveQuote');

  return (
    <Container component="section" maxWidth={false} classes={{ root: styles.root }} className={styles.container}>
      <Stack component={Container} maxWidth="md" alignItems="center" spacing={5} className={styles.content}>
        <Stack position="relative" textAlign="center" className={styles.quoteWrapper}>
          <Stack position="absolute" className={styles.quoteMark}>
            <Quote fill={colors.green700} />
          </Stack>
          <Typography variant="h5" component="blockquote" className={styles.quote}>
            {t('quote')}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={2} className={styles.authorBadge}>
          <Stack position="relative" className={styles.avatarWrapper}>
            <Image src="/images/avatars/ivan.webp" alt={t('author.name')} fill className={styles.avatar} />
          </Stack>
          <Stack spacing={0.25} className={styles.authorInfo}>
            <Typography variant="subtitle1" component="p" color={colors.white}>
              {t('author.name')}
            </Typography>
            <Typography variant="body1" color={colors.graytone300}>
              {t('author.role')}
            </Typography>
          </Stack>
          <IconButton
            href={t('author.linkedIn')}
            target="_blank"
            className={styles.linkedInLink}
            aria-label={`${t('author.name')} LinkedIn`}
          >
            <LinkedIn />
          </IconButton>
        </Stack>
      </Stack>
    </Container>
  );
};

export default ExecutiveQuoteSection;
